import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setDLStateOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'

export function* getDLStateOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getDLStateOptions,
    ])
    const { entity } = response
    yield put(setDLStateOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getDLStateOptions() error: ${e}`))
  }
}

export function* getDLStateOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDLStateOptions)
}
